// extracted by mini-css-extract-plugin
export var background = "_6m-0";
export var container = "_6m-1";
export var contentItem = "_6m-7";
export var extendedWarranty = "_6m-5";
export var link = "_6m-d";
export var modal = "_6m-b";
export var modalCloseButton = "_6m-9";
export var modalContent = "_6m-3";
export var modalContentMain = "_6m-6";
export var modalImageLogo = "_6m-8";
export var modalLogo = "_6m-a";
export var modalSideImage = "_6m-4";
export var preview = "_6m-c";
export var redoModal = "_6m-2";